// Imports

import React from 'react';
import { MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import './styles.css';

const index = ({ options, value, onChange, placeHolder, ...others }) => {
  const buttonStyle = {
    fontFamily: 'Mulish',
    backgroundColor: '#ffffff',
    textTransform: 'none',
    color: '#455066',
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: '400',
    letterSpacing: '0.01em',
  };

  return (
    <Select
      displayEmpty
      sx={{
        borderRadius: '20px',
        textAlign: others.multiple ? 'left' : 'center',
        padding: placeHolder ? '0px 12px' : '2px 12px',
        width: placeHolder ? '100%' : '101px',
        '& .MuiSelect-icon': {
          position: 'initial',
          color: '#054E8B',
        },
        '&::before': {
          borderColor: '#CAD3E5',
        },
        '&::after': {
          borderColor: '#CAD3E5',
        },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: '0px',
            border: 'solid #CAD3E5',
          },
        },
        MenuListProps: { disablePadding: true },
      }}
      className={'select-status'}
      style={buttonStyle}
      value={value}
      onChange={onChange}
      {...others}
    >
      {placeHolder && (
        <MenuItem
          disabled={others.multiple ? true : false}
          value=""
          sx={{
            p: '8px 12px',
            fontFamily: 'Mulish',
            fontSize: '12px',
            lineHeight: '13px',
            minHeight: 'fit-content',
            color: '#054E8B',
            borderBottom: 'solid #CAD3E5',
          }}
        >
          {placeHolder}
        </MenuItem>
      )}
      {options.map((element, index) => (
        <MenuItem
          value={element.value || element}
          key={index}
          sx={{
            p: '8px 12px',
            fontFamily: 'Mulish',
            fontSize: '12px',
            lineHeight: placeHolder ? '13px' : '15px',
            color: placeHolder ? '#054E8B' : 'inherit',
            minHeight: 'fit-content',
            borderBottom:
              index === options.length - 1 ? '0px' : 'solid #CAD3E5',
          }}
        >
          {element.name || element}
        </MenuItem>
      ))}
    </Select>
  );
};
index.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeHolder: PropTypes.string,
};
export default index;
